import useUrl from './helpers/useUrl'

/** @param {import('@nuxtjs/axios').NuxtAxiosInstance} client */
export default (client) => {
  const root = useUrl('user_documents')
  return {
    /** @param {Object} UploadDocumentDTO
      * @param {string} UploadDocumentDTO.type
      * @param {FormData} UploadDocumentDTO.formData */
    uploadDocument({ type, formData }) {
      const url = root(`upload/${type}`)
      return client.post(url, formData)
    },
    /** @returns {Promise<AxiosResponse<CheckDocumentStatusResponse>>} */
    checkDocumentStatus() {
      const url = root('status')
      return client.get(url)
    },
  }
}

/** @typedef {object} CheckDocumentStatusResponse
 * @property {boolean} status
 * @property {null} selfie_disaproved
 * @property {null} passport_disaproved
 * @property {null} diia_disaproved
 * @property {null} kycaid_disaproved
 * @property {string} selfie
 * @property {string} passport
 * @property {string} diia
 * @property {string} bankid
 * @property {string} kycaid
 */
